import { render, staticRenderFns } from "./ProjectAssetApprovalStatus.vue?vue&type=template&id=655cdd12"
import script from "./ProjectAssetApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ProjectAssetApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports